import cx from 'clsx';
import * as React from 'react';

import GhostTile from '@/components/modular-grid/GhostTile';

import { getRowStyle } from './stylesHelper';
import styles from './WidgetGrid.module.scss';

export const WidgetGridGhost: React.FC = () => {
  const createSlot = (key: number) => (
    <div className={styles.gridSlot} key={key}>
      <GhostTile />
    </div>
  );

  return (
    <div className={styles.container} data-testid={`widget-ghost-grid`}>
      <div className={styles.rowsWrapper}>
        <div className={cx(styles.widgetHeroSlot)}>
          <GhostTile />
        </div>

        <div className={styles.heroRow}>{[1, 2].map(i => createSlot(i))}</div>
        <div className={styles.rowsWrapperMedium}>
          <div className={styles.mediumRow}>{createSlot(3)}</div>
          <div className={styles.mediumRow}>
            {[4, 5].map(i => createSlot(i))}
          </div>
        </div>
      </div>

      <div className={cx(getRowStyle(undefined))}>
        {[6, 7, 8].map(i => createSlot(i))}
      </div>
    </div>
  );
};

export default WidgetGridGhost;
